import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const SmsDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} maxWidth="md">
      <DialogHeader onClose={handleClose}>{t('contract_documents_SMS_howDoesItWork')}</DialogHeader>
      <DialogContent>
        <List>
          {Array(7)
            .fill(0)
            .map((_x, i) => {
              return (
                <ListItem>
                  <ListItemText>{t(`contract_documents_sms_${i + 1}`)}</ListItemText>
                </ListItem>
              );
            })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="default">
          {t('general_agreed')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SmsDialog;
